import React from 'react';

export default function Terms() {
  return (
    <main className="legal-page">
      <div className="legal-inner">
        <h1>利用規約</h1>
        <p className="legal-updated">最終更新日：2026年5月9日</p>

        <section>
          <h2>1. はじめに</h2>
          <p>
            本利用規約（以下「本規約」）は、FakeScan（以下「本サービス」）の利用条件を定めるものです。
            本サービスをご利用いただくことで、本規約に同意したものとみなします。
          </p>
        </section>

        <section>
          <h2>2. サービス概要</h2>
          <p>
            本サービスは、AIが生成したフェイク画像や人為的に加工された画像を検出する解析ツールです。
            会員登録不要・完全無料でご利用いただけます。
          </p>
          <p>
            本サービスの解析結果はあくまで参考情報であり、画像の真正性を100%保証するものではありません。
          </p>
        </section>

        <section>
          <h2>3. 禁止事項</h2>
          <p>以下の行為を禁止します。</p>
          <ul>
            <li>違法なコンテンツ（児童ポルノ・著作権侵害物等）を含む画像のアップロード</li>
            <li>第三者のプライバシーを侵害する目的での利用</li>
            <li>サービスへの過度な負荷をかける行為（スパム・自動化ツールによる大量リクエスト等）</li>
            <li>本サービスのリバースエンジニアリング・改ざん・不正アクセスの試み</li>
            <li>その他、法令または公序良俗に反する行為</li>
          </ul>
        </section>

        <section>
          <h2>4. アップロード画像について</h2>
          <p>
            アップロードする画像について、利用者自身が適法に取り扱う権利を有していることを確認してください。
            第三者の著作物・肖像権が含まれる画像をアップロードする場合は、適切な権利処理を行ってください。
          </p>
          <p>
            アップロードされた画像はサーバーに保存されず、解析後即時破棄されます。
          </p>
        </section>

        <section>
          <h2>5. 免責事項</h2>
          <p>
            本サービスの解析結果は統計的・技術的手法に基づく参考情報です。以下の点についてご注意ください。
          </p>
          <ul>
            <li>解析結果の正確性・完全性は保証されません</li>
            <li>解析結果を根拠とした判断・行動によって生じた損害について、運営者は責任を負いません</li>
            <li>サービスの中断・停止・変更・終了によって生じた損害についても、運営者は責任を負いません</li>
          </ul>
        </section>

        <section>
          <h2>6. サービスの変更・終了</h2>
          <p>
            運営者は予告なく本サービスの内容を変更・停止・終了する場合があります。
          </p>
        </section>

        <section>
          <h2>7. オープンソースライセンス</h2>
          <p>
            本サービスのソースコードはMITライセンスのもとで公開されています。
          </p>
        </section>

        <section>
          <h2>8. 規約の変更</h2>
          <p>
            本規約は予告なく変更される場合があります。変更後はこのページに掲載し、最終更新日を更新します。
            変更後も本サービスを利用し続けた場合、変更後の規約に同意したものとみなします。
          </p>
        </section>

        <section>
          <h2>9. 準拠法・管轄</h2>
          <p>
            本規約は日本法に準拠し、本サービスに関する紛争は日本の裁判所を専属的合意管轄とします。
          </p>
        </section>

        <section>
          <h2>10. お問い合わせ</h2>
          <p>
            本規約に関するお問い合わせは、<a href="/contact">お問い合わせページ</a>よりご連絡ください。
          </p>
        </section>
      </div>
    </main>
  );
}
